<sui-dialog-simple>
  <ng-template suiDialogHeader>
    <h2 ngpDialogTitle>
      {{ title }}
    </h2>
    <sui-button
      size="sm"
      variant="danger"
      shape="round"
      [leadingIcon]="['fas', 'times']"
      [iconOnly]="true"
      ariaLabel="Close"
      (click)="cancel()"
    ></sui-button>
  </ng-template>

  <ng-template suiDialogContent>
    <p class="constraints-info-message">
      {{ message }}
    </p>
    <app-business-constraints-info
      [errors]="errors"
    ></app-business-constraints-info>
  </ng-template>

  <ng-template suiDialogFooter>
    <sui-button variant="primary" (click)="cancel()">
      {{ "btn.acknowledge" | translate }}
    </sui-button>
  </ng-template>
</sui-dialog-simple>
